module.exports = __webpack_public_path__ + "static/media/Admindash.4331249f.png";